import React, {Component} from 'react';
import UserStatus from '../../Employees/UserStatus';
//css
import './teamMember-detail.css';

class TeamMemberDetail extends Component {
  render () {
    return (
      <div className="edit-member-detail">
        <UserStatus
          {...this.props}
          editModeId={this.props.location.search.split('=')[1]}
          roleId="51"
          ifForInternalPage={true}
          selected_client={this.props.match.params.id}
          userId={this.props.match.params.id}
        />
      </div>
    )
  }
}

export default TeamMemberDetail;


// WEBPACK FOOTER //
// ./src/components/Clients/EditClientProfile/TeamMemberDetail.jsx